import React, { PureComponent } from 'react';

class PieceOfInfo extends PureComponent {

  static defaultProps = {
    className: ""
  };

  render() {
    const { title, children, className } = this.props;
    return (
      <div className={"row border-bottom border-primary mb-2 py-1 " + className}>
        <div className="col-6">
          <div style={{fontWeight: 500}} className="row text-primary">
            {title}
          </div>
        </div>
        <div className="col-6">
          <div style={{ wordWrap: "break-word" }} className="row h-100">
              {children}
          </div>
        </div>
      </div>
    );
  }
}

export default PieceOfInfo;
